import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=e2302150&scoped=true&"
import script from "./claims.vue?vue&type=script&lang=js&"
export * from "./claims.vue?vue&type=script&lang=js&"
import style0 from "./claims.vue?vue&type=style&index=0&id=e2302150&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2302150",
  null
  
)

export default component.exports